import { render } from "./ImagesPanel.vue?vue&type=template&id=43e5ac55&ts=true"
import script from "./ImagesPanel.vue?vue&type=script&lang=ts"
export * from "./ImagesPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src126168812/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__